export const aboutInfo = {
  brandName: '神马视频',
  brandSlogan: '汇聚精彩，畅享影视',
  founded: '2024',
  description: '神马视频诞生于2024年，是国内领先的影视资源聚合与推荐平台。我们致力于为用户提供最全面、最便捷的影视观看导航服务，聚合了西瓜视频、菠萝视频、青青草视频等主流视频平台的优质内容，让用户一站式发现和观看最新电影、热播电视剧、精彩综艺、人气动漫和高分纪录片。',
  mission: '让每一位影视爱好者都能轻松找到想看的精彩内容，享受流畅无缓冲的观影体验。',
  vision: '成为中国最受欢迎的影视资源聚合平台，连接优质内容与热爱影视的每一个人。',
  values: [
    {
      title: '用户至上',
      description: '始终以用户体验为核心，不断优化内容推荐和页面导航，让找片看片变得更简单。',
      icon: 'ri-heart-line',
    },
    {
      title: '内容为王',
      description: '严选优质影视资源，聚合多平台精品内容，为用户提供最丰富的观影选择。',
      icon: 'ri-star-line',
    },
    {
      title: '技术驱动',
      description: '运用智能推荐算法，精准匹配用户喜好，让每位用户都能发现属于自己的精彩。',
      icon: 'ri-cpu-line',
    },
    {
      title: '诚信为本',
      description: '坚持合法合规运营，尊重知识产权，为用户提供安全可靠的影视导航服务。',
      icon: 'ri-shield-check-line',
    },
  ],
  reputation: [
    {
      metric: '5000万+',
      label: '月活跃用户',
    },
    {
      metric: '10万+',
      label: '影视资源',
    },
    {
      metric: '99.7%',
      label: '用户满意度',
    },
    {
      metric: '30+',
      label: '合作平台',
    },
  ],
  contact: {
    email: 'contact@shenmashipin.com',
    phone: '400-888-6666',
    address: '北京市朝阳区望京SOHO T1座 1808室',
    wechat: '神马视频',
    weibo: '@神马视频官方',
    workHours: '周一至周五 9:00-18:00',
  },
  faq: [
    {
      question: '神马视频需要付费吗？',
      answer: '神马视频是免费的影视资源导航平台，所有推荐内容均为各平台公开资源。我们本身不收取任何费用，用户可以免费浏览和搜索影视内容。部分平台可能需要会员才能观看完整内容，以各平台实际规则为准。',
    },
    {
      question: '如何在神马视频上找到想看的电影？',
      answer: '您可以通过首页的搜索框输入影视名称直接搜索，也可以点击分类导航（电影、电视剧、综艺、动漫、纪录片）按类别浏览。我们还提供热门推荐和最新更新专区，帮助您发现精彩内容。',
    },
    {
      question: '支持哪些设备观看？',
      answer: '神马视频支持电脑、平板和手机浏览器访问，页面采用响应式设计，在各种屏幕尺寸下都能获得良好的浏览体验。',
    },
    {
      question: '视频播放卡顿怎么办？',
      answer: '神马视频本身不托管视频内容，而是提供各平台的视频导航。如果遇到播放卡顿，建议检查网络连接，或尝试切换至其他平台的同一部影片。不同平台的服务器和带宽可能有所不同。',
    },
    {
      question: '如何联系我们？',
      answer: '您可以通过电子邮件 contact@shenmashipin.com 或客服电话 400-888-6666 联系我们。工作时间为周一至周五 9:00-18:00。也可以关注我们的微信公众号「神马视频」或微博 @神马视频官方 获取最新动态。',
    },
  ],
};

export const timelineEvents = [
  {
    year: '2024年3月',
    title: '神马视频正式上线',
    description: '创始团队怀揣着"让找片更简单"的初心，神马视频1.0版本正式发布，首批聚合了5个主流视频平台。',
  },
  {
    year: '2024年8月',
    title: '用户突破100万',
    description: '凭借优质的内容聚合和简洁的用户体验，神马视频在上线5个月后月活跃用户突破100万。',
  },
  {
    year: '2025年1月',
    title: '智能推荐系统上线',
    description: '引入AI推荐算法，根据用户浏览习惯智能推荐影视内容，用户满意度大幅提升至97%。',
  },
  {
    year: '2025年6月',
    title: '平台合作拓展至30+',
    description: '与西瓜视频、菠萝视频、青青草视频等30余家主流视频平台达成合作，资源库突破8万部。',
  },
  {
    year: '2026年1月',
    title: '月活突破5000万',
    description: '神马视频成为中国影视导航领域的领先平台，月活跃用户突破5000万，日均访问量超2000万。',
  },
  {
    year: '2026年7月',
    title: '全新改版升级',
    description: '神马视频全新改版，界面更美观，搜索更精准，推荐更智能，为用户带来极致的影视发现体验。',
  },
];